/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Erp_Vat_CodeInputs */

const en_reference_dataset_erp_vat_code = /** @type {(inputs: Reference_Dataset_Erp_Vat_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VAT codes for the ERP`)
};

/**
* | output |
* | --- |
* | "VAT codes for the ERP" |
*
* @param {Reference_Dataset_Erp_Vat_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_erp_vat_code = /** @type {((inputs?: Reference_Dataset_Erp_Vat_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Erp_Vat_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_erp_vat_code(inputs)
});